module.exports = __webpack_public_path__ + "static/img/cloud-left_bottom-min.ad5d451.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/cloud-left_bottom-min.png
// module id = 656
// module chunks = 64